import React, { useEffect, useState } from 'react';
import '../styles/VisiteWidget.css'; // Assurez-vous d'avoir un fichier CSS pour les styles
import schedule from '../assets/schedule.png';

const VisiteWidget = () => {
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleWindowFocus = () => {
      setIsHovered(false);
    };

    window.addEventListener('focus', handleWindowFocus);

    return () => {
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, []);

  const handleMouseEnter = () => {
    if (window.innerWidth > 768) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) {
      setIsHovered(false);
    }
  };

  return (
    <div className="visite-widget">
      <a
        href="/pages/InformationsPratiques"
        target="_blank"
        rel="noopener noreferrer"
        className="visite-button"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={schedule}
          alt="Euro"
          className="visite-icon"
          style={{ opacity: isHovered ? '0' : '1' }}
        />
        <span
          className="visite-text"
          style={{ display: isHovered ? 'block' : 'none' }}
        >
          Informations pratiques
        </span>
      </a>
    </div>
  );
};

export default VisiteWidget;
